(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/form/assets/javascripts/components/label.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/form/assets/javascripts/components/label.trinidad.js');
"use strict";

(() => {
  "use strict";

  const __webpack_require__ = {};
  __webpack_require__.n = module => {
const getter = module && module.__esModule ? () => module['default'] : () => module;
    __webpack_require__.d(getter, {
      a: getter
    });
    return getter;
  };
  __webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
          enumerable: true,
          get: definition[key]
        });
      }
    }
  };
  __webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  let __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => (label)
  });
  ; 
  const external_React_namespaceObject = window["React"];
  ; 
  const external_PropTypes_namespaceObject = window["PropTypes"];
  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);
  ; 

  const Label = _ref => {
    let alignRight = _ref.alignRight,
      classes = _ref.classes,
      id = _ref.id,
      isButton = _ref.isButton,
      children = _ref.children,
      title = _ref.title,
      centeredLabel = _ref.centeredLabel;
    return React.createElement("label", {
      className: "form-label form-label-align-".concat(alignRight ? 'right' : 'left', " ").concat(classes ? classes : ''),
      htmlFor: id
    }, isButton && React.createElement("div", {
      className: "form-label-btn"
    }), children && React.createElement("div", {
      className: "form-label-text".concat(centeredLabel ? ' align-center' : '')
    }, title ? React.createElement(external_React_namespaceObject.Fragment, null, React.createElement("span", {
      className: "form-label-text-title"
    }, title), React.createElement("span", {
      className: "form-label-text-content"
    }, children)) : children));
  };
  Label.__docgenInfo = {
    "description": "",
    "methods": [],
    "displayName": "Label",
    "props": {
      "alignRight": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "centeredLabel": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "children": {
        "description": "",
        "type": {
          "name": "node"
        },
        "required": false
      },
      "classes": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "id": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": true
      },
      "isButton": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "title": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      }
    }
  };
  const label = Label;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactForm = window.svs.ui.ReactForm || {}).Label = __webpack_exports__["default"];
})();

 })(window);